export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    image: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      hasTwoColumns: true,
    };
  },

  computed: {
    wrapperClasses() {
      return ['grid', { 'gap-y-base gap-x-lg lg:gap-x-2xl md:grid-cols-2': this.hasImage }];
    },

    gridClasses() {
      return ['grid gap-md', { 'md:grid-cols-2': !this.hasImage && this.hasTwoColumns }];
    },

    columnClasses() {
      return ['flex flex-col gap-md'];
    },

    hasImage() {
      return this.image !== null;
    },
  },
};
